import { NotFound } from '@britishcouncil/react-admin';

import { ROUTING_PATHS } from 'const';
import { BreadcrumbRouteObject } from 'types';
import { BULK_ACTIONS_ROUTES } from './bulk-actions/bulk-actions-routes';
import { EXAMINER_ROUTES } from './examiner';
import { EXAMINERS_ROUTES } from './examiners';
import { REPORTS_ROUTES } from './reports';
import { USERS_ROUTES } from './users';
import { Welcome } from './welcome';

const { welcome, dashboard } = ROUTING_PATHS;

export const APP_ROUTES: BreadcrumbRouteObject[] = [
  { path: welcome, element: <Welcome /> },
  {
    path: dashboard.path,
    lazy: () => import('./dashboard'),
    breadcrumb: { text: 'Dashboard', icon: 'dashboard' },
  },
  ...USERS_ROUTES,
  ...EXAMINERS_ROUTES,
  ...EXAMINER_ROUTES,
  ...REPORTS_ROUTES,
  ...BULK_ACTIONS_ROUTES,
  { path: '*', element: <NotFound /> },
];
